import * as devisConf from '@/configuration/devisConf';
import defineTitreIntervenant from '@/services/devisCommandes/defineTitreIntervenant';
import i18n from '@/i18n';
import store from '@/store/store';

export default function addIntervenant(devisCommande, intervenant) {
  if (!devisCommande) {
    return;
  }
  if (devisCommande.intervenants === null || devisCommande.intervenants === undefined) {
    devisCommande.intervenants = [];
  }
  let nbIntervenant = 0;
  devisCommande.intervenants.forEach(inter => {
    if (inter.tiersId && inter !== undefined) {
      nbIntervenant += 1;
    }
  });
  if (nbIntervenant === 0) {
    intervenant.payeur = true;
    intervenant.donneurOrdre = true;
    intervenant.annonceur = true;
    defineTitreIntervenant(intervenant, i18n);
    intervenant.repartition = 100;
    intervenant.typeRepartition = devisConf.POURCENTAGE;
    if (intervenant.role) {
      const societeActive = store.getters['societe/societeActive'];
      const roleFind = societeActive.roles.some((role) => {
        return role === intervenant.role;
      });
      if (roleFind) {
        devisCommande.role = intervenant.role;
      }
    }
  }
  devisCommande.intervenants.splice(devisCommande.intervenants.length - 1, 0, intervenant);
}
